import { MissionManagerAccessMode } from "@a_team/models/dist/MissionObject";
import MissionRole from "@a_team/models/dist/MissionRole";
import { BasicUserObject } from "@a_team/models/dist/UserObject";

export interface MissionManagerPayload {
  _id: string;
  accessMode: MissionManagerAccessMode.RoleView;
  excludeFromTeamPulseEmails?: boolean;
  excludeFromInvoiceEmails?: boolean;
  excludeFromBuilderFeedbackEmails?: boolean;
  excludeFromMissionUpdatesEmails?: boolean;
}

export enum EmailSettings {
  Invoices = "invoices",
  TeamPulse = "teamPulse",
  BuilderFeedback = "builderFeedback",
  MissionUpdates = "missionUpdates",
}

export interface EnrichedMissionRole extends MissionRole {
  user: BasicUserObject | null;
}
